<template>
  <b-modal title="Detalhes do Liquído Penetrante" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Material:" label-for="material" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="material" v-model="template.material" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Técnica:" label-for="tecnica" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="tecnica" v-model="template.tecnica" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Via:" label-for="via" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="via" v-model="template.via" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Tipo:" label-for="tipo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="tipo" v-model="template.tipo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Temperatura:" label-for="temperatura" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="temperatura" v-model="template.temperatura" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Superfície:" label-for="superficie" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="superficie" v-model="template.superficie" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Norma:" label-for="norma" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="norma" v-model="template.norma" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Procedimento:" label-for="procedimento" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.procedimento">
              <b-form-select-option v-for="documento of getDocumentos" v-bind:key="documento.id" :value="documento.numero"
                >{{ documento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Penetrante:" label-for="penetrante" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.penetrante">
              <b-form-select-option v-for="penetrante of getConsumiveis" v-bind:key="penetrante.id" :value="penetrante"
                >{{ penetrante.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Revelador:" label-for="revelador" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.revelador">
              <b-form-select-option v-for="revelador of getConsumiveis" v-bind:key="revelador.id" :value="revelador"
                >{{ revelador.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label-cols-sm="2" label="Observação:" label-align-sm="center">
            <b-form-textarea v-model="template.observacao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col cols="6">
          <b-form-group label="Inspetor:" label-for="inspetor" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.inspetor">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <template-lp-modal ref="templateLiquido" @loadTemplate="loadTemplate($event)" />

    <template #modal-footer>
      <b-button variant="info" @click="templates()">Templates</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useDocumentoStore } from "@/stores/DocumentoStore";
import { useConsumivelStore } from "@/stores/ConsumivelStore";
import { useInstrumentoStore } from "@/stores/InstrumentoStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import LiquidoPenetrante from "@/models_reports/LiquidoPenetrante";
import InspecaoTemplateModal from "@/components/modals/template/InspecaoTemplateModal";

export default {
  name: "ModalDeTemplateLP",

  components: {
    "template-lp-modal": InspecaoTemplateModal,
  },

  data() {
    return {
      show: false,
      template: new LiquidoPenetrante(),
    };
  },

  methods: {
    templates() {
      this.$refs.templateLiquido.call();
    },

    loadTemplate(template) {
      this.template.observacao = template.observacao;
      for (var i = 0; i < template.itens.length; i++) {
        this.template.itens[i].quantidade = template.itens[i].quantidade;
        this.template.itens[i].descricao = template.itens[i].descricao;
        this.template.itens[i].local = template.itens[i].local;
        this.template.itens[i].tipo = template.itens[i].tipo;
        this.template.itens[i].dimensao = template.itens[i].dimensao;
        this.template.itens[i].laudo = template.itens[i].laudo;
      }
    },

    call(lp) {
      this.show = !this.show;
      this.template = lp;
    },
  },

  setup() {
    const store = useSgcqStore();
    const documentoStore = useDocumentoStore();
    const { getDocumentos } = storeToRefs(documentoStore);
    const instrumentoStore = useInstrumentoStore();
    const { getInstrumentos } = storeToRefs(instrumentoStore);
    const consumivelStore = useConsumivelStore();
    const { getConsumiveis } = storeToRefs(consumivelStore);
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      documentoStore,
      getDocumentos,
      instrumentoStore,
      getInstrumentos,
      consumivelStore,
      getConsumiveis,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped></style>
